import {
  ContactForm,
  ProfileForm,
  SchoolForm,
  CoursesForm,
  Pupil,
  PupilAddress,
} from '@lyceo/homi/pupils/util-models';

export function mapContactForm(address?: PupilAddress): ContactForm {
  return {
    email: address?.email ?? '',
    phone: address?.phone ?? '',
    street: address?.street ?? '',
    zipcode: address?.zipcode ?? '',
    city: address?.city ?? '',
  };
}

export function mapProfileForm(pupil?: Pupil): ProfileForm {
  return {
    firstName: pupil?.firstName ?? '',
    lastName: pupil?.lastName ?? '',
  };
}

export function mapSchoolForm(pupil?: Pupil): SchoolForm {
  return {
    school: pupil?.schoolName ?? '',
    level: pupil?.level ?? '',
    year: (pupil?.year ?? '').toString(),
    schoolClass: pupil?.pupilClass ?? '',
  };
}

export function mapCoursesForm(pupil?: Pupil): CoursesForm {
  return {
    courseIds: pupil?.courseIds ?? [],
  };
}
